import { useFieldArray, useFormContext } from "react-hook-form";
import {
  IntegrationSettingsForm,
  IntegrationSettingsOptionToAddForm,
  IntegrationSettingsTypedInputProps,
} from "modules/integrationSettings/types";
import { Box, Grid2, IconButton, Stack, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { OptionToAddForm } from "./OptionToAddForm";

export const OptionSetInput = ({ integrationSettingsEntry, dataKey }: IntegrationSettingsTypedInputProps) => {
  const { control, getValues } = useFormContext<IntegrationSettingsForm>();

  const { fields, prepend, remove } = useFieldArray({
    control,
    name: `${integrationSettingsEntry.level}.${dataKey}.integrationSettingsValues.${integrationSettingsEntry.name}`,
  });

  const handleAdd = (optionToAdd: IntegrationSettingsOptionToAddForm) => {
    prepend(optionToAdd);
  };

  const handleRemove = (index: number) => {
    remove(index);
  };

  return (
    <Box display="flex" flexDirection="column">
      <Stack gap={1}>
        <OptionToAddForm integrationSettingsEntry={integrationSettingsEntry} onAdd={handleAdd} />
        {fields.map((field, fieldIndex) => (
          <Grid2 key={field.id} container spacing={2}>
            <Grid2 size={6} display="flex" alignItems="center">
              <Typography>
                {getValues(
                  `${integrationSettingsEntry.level}.${dataKey}.integrationSettingsValues.${integrationSettingsEntry.name}.${fieldIndex}.displayName`
                )}
              </Typography>
            </Grid2>
            <Grid2 size={4} display="flex" alignItems="center">
              <Typography>
                {getValues(
                  `${integrationSettingsEntry.level}.${dataKey}.integrationSettingsValues.${integrationSettingsEntry.name}.${fieldIndex}.value`
                )}
              </Typography>
            </Grid2>
            <Grid2 size={2}>
              <IconButton aria-label="delete" color="error" onClick={() => handleRemove(fieldIndex)}>
                <DeleteIcon />
              </IconButton>
            </Grid2>
          </Grid2>
        ))}
      </Stack>
    </Box>
  );
};
